import React from 'react';
import {connect} from "react-redux";
import {authActions, form, storeFromArea} from "@mc/mc-legacy";
import {Redirect} from "react-router-dom";
import {Col, Row} from "reactstrap";

const {LoginForm} = form;

class LoginAdminPage extends React.Component {
    static defaultProps = {
        from: "/",
    };
    props: {
        authInfo: {
            data: AuthStatus;
            fetched: boolean;
        };
        from: string;
    };

    render() {
        const {authInfo} = this.props;
        const {from} = this.props.location.state || {
            from: {
                pathname: "/",
            },
        };

        if (authInfo.data && authInfo.data.auth) {
            return <Redirect to={from}/>;
        }

        return (
            <div className="container">
                <Row className="justify-content-center pt-5">
                    <Col
                        xs="12"
                        sm={{
                            size: 4,
                            offset: 4,
                        }}
                        md={{
                            size: "auto",
                            offset: 0,
                        }}
                    >
                        <h2>Přihlášení do administrace QSIGN</h2>
                        <LoginForm/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect((state, props) => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
}))(LoginAdminPage);
